export default __webpack_public_path__ + "static/media/community-topborder.e887157d.svg";